import React from 'react';

import { homepageCarousalArrowIcon } from '@assets/images';

import WFImg from '@components/atoms/Image/Img';

interface IProps {
    onClick?: any;
    style?: any;
    className?: string;
    customStyle?: string;
    isLeft?: boolean;
}

export default function (props: IProps) {
    const { onClick, style, className, isLeft, customStyle} = props;

    const customClass = ['wf_slider_arrow', customStyle].join(' ');
    return (
        <div
            className={`${customClass} ${!onClick && 'disable_slider'}`}
            style={{ ...style, display: "block" }}
            onClick={onClick}
        >
            <WFImg src={homepageCarousalArrowIcon} className={`arrow ${isLeft && 'left_arrow'}`} />
        </div>
    )
}
